module.exports = __webpack_public_path__ + "img/hdgl.6d525eca.svg";